import { render } from "./Paginacao.vue?vue&type=template&id=39db6267&scoped=true&ts=true"
import script from "./Paginacao.vue?vue&type=script&lang=ts"
export * from "./Paginacao.vue?vue&type=script&lang=ts"

import "./Paginacao.vue?vue&type=style&index=0&id=39db6267&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39db6267"],['__file',"src/components/Paginacao/Paginacao.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39db6267"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39db6267', __exports__)) {
    api.reload('39db6267', __exports__)
  }
  
  module.hot.accept("./Paginacao.vue?vue&type=template&id=39db6267&scoped=true&ts=true", () => {
    api.rerender('39db6267', render)
  })

}


export default __exports__